module.exports = __webpack_public_path__ + "media/images/static/top/local/MV ローカル-eb383505e9e8d15b5139f9e7e93708b4.png";